import { render, staticRenderFns } from "./ModalMedicamento.vue?vue&type=template&id=60b9b11a"
import script from "./ModalMedicamento.vue?vue&type=script&lang=ts"
export * from "./ModalMedicamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports